import React from 'react';
import './BgmMiniPlayer.css';

interface BgmMiniPlayerProps {
  trackName: string;
  isPlaying: boolean;
  progress: number; // 0-1
  onPlay: () => void;
  onStop: () => void;
  onOpenModal: () => void;
}

const BgmMiniPlayer: React.FC<BgmMiniPlayerProps> = ({
  trackName,
  isPlaying,
  progress,
  onPlay,
  onStop,
  onOpenModal,
}) => {
  return (
    <div className="bgm-mini-player">
      {/* Progress bar */}
      {isPlaying && (
        <div className="bgm-mini-player__progress">
          <div
            className="bgm-mini-player__progress-fill"
            style={{ width: `${progress * 100}%` }}
          />
        </div>
      )}

      <div className="bgm-mini-player__content">
        {/* Play / Stop toggle */}
        <button
          className="bgm-mini-player__btn"
          onClick={(e) => {
            e.stopPropagation();
            isPlaying ? onStop() : onPlay();
          }}
          aria-label={isPlaying ? 'Stop BGM' : 'Play BGM'}
        >
          {isPlaying ? (
            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="6" width="12" height="12" rx="2" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 5v14l11-7z" />
            </svg>
          )}
        </button>

        {/* Track name - tap to open modal */}
        <span className="bgm-mini-player__name" onClick={onOpenModal}>
          {isPlaying ? trackName : 'BGM'}
        </span>

        {/* Music icon - tap to open modal */}
        <button
          className="bgm-mini-player__modal-btn"
          onClick={onOpenModal}
          aria-label="Open BGM list"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18V5l12-2v13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="6" cy="18" r="3" fill="currentColor" opacity="0.7" />
            <circle cx="18" cy="16" r="3" fill="currentColor" opacity="0.7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default BgmMiniPlayer;
